import React from 'react';

interface InvalidFeedbackProps extends React.HTMLAttributes<HTMLDivElement> {
    errorClassName?: string;
}

export const InvalidFeedback = ({ errorClassName, ...props }: InvalidFeedbackProps) => {
    return <div className={`text-error ${errorClassName || 'pt-1 text-sm'}`} {...props} />;
};
